/* eslint-disable no-underscore-dangle */
import { useState } from "react";
import { isArray } from "lodash";
import { func, shape, string } from "prop-types";
import { useDispatch } from "react-redux";
import Button from "@shared/v2/Button";
import { TrashCanSolidV6, PlusSolidV6 } from "@shared/v2/Icomoon";
import TextComboInput from "@shared/v2/TextComboInput";
import TextButton from "@shared/v2/TextButton";
import IconPickerModal from "@shared/IconPickerModal";
import { isStrInputLen } from "../../ModalViews/helpers";
import { useContactPerson } from "../../../reducers/contactsReducer/selectors";
import { addCustomLink, deleteCustomLink, setCustomLink } from "../../../reducers/contactsReducer";

const STYLES = {
  button:
    "tw-w-[36px] tw-h-[36px] tw-flex tw-items-center tw-justify-center !tw-rounded-[4px] !tw-border-gray-15 tw-border-solid tw-border tw-border-width-[1px] !tw-bg-transparent",
};

const { button } = STYLES;

const CustomLink = ({ onDelete, onTitleChange, setIconPickerCustomLink, customLink, onURLChange }) => {
  const {
    name,
    value,
    meta: { icon },
  } = customLink;
  return (
    <div className="tw-flex tw-gap-8px">
      <Button className={button} onClick={() => setIconPickerCustomLink(customLink)}>
        <i className={`${icon} tw-text-gray-75 tw-text-[20px]`} />
      </Button>
      <TextComboInput
        placeholder="Link Name"
        value={name}
        onChange={(e) => onTitleChange(e.target.value)}
        error={isStrInputLen(name)}
        containerClassName="tw-flex-1"
        isRequired
      />
      <TextComboInput
        placeholder="URL"
        value={value}
        onChange={(e) => onURLChange(e.target.value)}
        error={isStrInputLen(value)}
        containerClassName="tw-flex-1"
        isRequired
      />
      <Button className={button} onClick={onDelete}>
        <TrashCanSolidV6 size="xl" className="tw-text-gray-75" />
      </Button>
    </div>
  );
};

const CustomLinks = () => {
  const [iconPickerCustomLink, setIconPickerCustomLink] = useState(null);
  const dispatch = useDispatch();
  const { customLinksAttributes } = useContactPerson();

  const customLinks = isArray(customLinksAttributes) ? customLinksAttributes : [];

  return (
    <>
      <div className="tw-flex tw-flex-col tw-gap-[8px]">
        {customLinks
          .filter((customLink) => !customLink._destroy)
          .map((customLink) => (
            <CustomLink
              key={customLink.position}
              customLink={customLink}
              onTitleChange={(name) => dispatch(setCustomLink({ position: customLink.position, name }))}
              onURLChange={(value) => dispatch(setCustomLink({ position: customLink.position, value }))}
              onDelete={() => dispatch(deleteCustomLink({ position: customLink.position }))}
              setIconPickerCustomLink={setIconPickerCustomLink}
            />
          ))}
      </div>
      <TextButton onClick={() => dispatch(addCustomLink())} className="tw-w-[90px] tw-p-0">
        <PlusSolidV6 size="s" />
        <span className="tw-ml-[4px]">Custom Link</span>
      </TextButton>
      <IconPickerModal
        onHide={() => setIconPickerCustomLink(false)}
        onSelect={(icon) =>
          dispatch(setCustomLink({ position: iconPickerCustomLink.position, meta: { icon } }))
        }
        show={iconPickerCustomLink}
      />
    </>
  );
};

export default CustomLinks;

CustomLink.propTypes = {
  onDelete: func.isRequired,
  setIconPickerCustomLink: func.isRequired,
  onTitleChange: func.isRequired,
  onURLChange: func.isRequired,
  customLink: shape({
    meta: shape({
      icon: string,
    }).isRequired,
    position: string.isRequired,
    name: string,
    value: string,
  }).isRequired,
};
